import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { useCarsState } from '../providers/CarsProvider';

import { validateDepenencies } from '../helpers/cars';

const OptionGroup = ( { id, slug, label, options, data, select_multiple_options, show_in_navigation } ) => {

    const [ carsState, carsDispatch ] = useCarsState();

    const [ visible, setVisible ] = useState( false );

    const handleOnClick = e => {

        e.stopPropagation();

        carsDispatch( { type:'setSelectedGroup', data: { id, slug, options, data, select_multiple_options, label } } );
    }

    const selected = carsState.selectedGroup && carsState.selectedGroup.id == id;

    useEffect( () => {

        setVisible( validateDepenencies( carsState.currentConfiguration, data.dependencies ) );

    }, [ carsState.currentConfiguration ] )

    return <button onClick={ handleOnClick } className={`${ selected ? 'brdr-admin-accent' : 'brdr-transparent' }`} style={{ pointerEvents:'all', display: ( show_in_navigation && visible == true ) ? 'block' : 'none', paddingBottom:4, marginBottom: selected ? 6 : 0, borderBottom: selected ? `1px solid` : 'none' }} >
        <h6 className={`no-wrap medium ${ selected ? 'text-admin-accent' : 'text-gray'}`}>{ label  }</h6>
    </button>
}

OptionGroup.propTypes = {
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    data: PropTypes.object,
    options: PropTypes.array,
    select_multiple_options: PropTypes.bool,
    show_in_navigation: PropTypes.bool
}

export default OptionGroup;